import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { observer } from 'mobx-react'
import React from 'react'

function DataUnit({ name = '', value, icon = null }) {
  return (
    <Box>
      <Typography variant={'body2'} color={'grey.500'} sx={{ lineHeight: 1 }}>
        {name}
      </Typography>

      <Box
        mt={0.5}
        className={'aln-center'}
        sx={{ justifyContent: 'space-between', width: '100%' }}
      >
        {!!icon && (
          <img
            alt={''}
            src={icon}
            className={'mr-8'}
            style={{ width: '20px', height: '20px' }}
          />
        )}
        <Typography
          sx={
            value === 'Обслуживание невозможно'
              ? { width: '110px' }
              : { width: '100%' }
          }
          variant={'subtitle1'}
        >
          {value || '-'}
        </Typography>
      </Box>
    </Box>
  )
}

export default observer(DataUnit)
